export const enumToStringArray = <T extends Record<string, string | number>>(e: T): string[] =>
  Object.values(e).filter((v) => typeof v === "string") as string[];

export const enumToEntries = <T extends Record<string, string | number>>(e: T) => {
  // Filter for only the numeric keys to avoid duplicates from the reverse mapping
  return Object.keys(e)
    .filter((key) => isNaN(Number(key)))
    .map((key) => ({
      label: key, // e.g., "BUY"
      value: e[key], // e.g., 1
    }));
};
